import { dynamicWrapper, createRoute } from '@/utils/core';

const routesConfig = app => ({
  path: '/stationNews',
  title: window.language["homepage.navBar.systemInformation"],
  component: dynamicWrapper(app, [import('./model')], () => import('./components'))
});

export default app => createRoute(app, routesConfig);



// WEBPACK FOOTER //
// ./src/routes/NavBar/StationNews/index.js